export enum TemplateType {
  INVOICE = 'INVOICE',
  SUPPLIER_INVOICE = 'SUPPLIER_INVOICE',
  CUSTOMER_CREDIT_NOTE = 'CUSTOMER_CREDIT_NOTE',
  SUPPLIER_CREDIT_NOTE = 'SUPPLIER_CREDIT_NOTE',
  CREDIT_NOTE = 'CREDIT_NOTE',
  RECEIPT = 'RECEIPT',
  PAYMENT = 'PAYMENT',
  Protection = 'Protection',
  Authorisation = 'Authorisation',
  Agreement = 'Agreement',
  INVOICE_PROFORMA = 'INVOICE_PROFORMA',
  PAYMENTADVICE = 'PaymentAdvice',


  MISC_TAX_INVOICE = 'misc_tax_invoice',
  MISC_BANK_REFERRAL_FEETAX_INVOICE = 'misc_bank_referral_feetax_invoice',

  MISC_TAX_INVOICE_HI = 'misc_tax_invoice_hi',
  MISC_BANK_REFERRAL_FEETAX_INVOICE_HI = 'misc_bank_referral_feetax_invoice_hi',

  MISC_TAX_INVOICE_HC = 'misc_tax_invoice_hc',
  MISC_BANK_REFERRAL_FEETAX_INVOICE_HC = 'misc_bank_referral_feetax_invoice_hc',
  MISC_BANK_REFERRAL_FEETAX_INVOICE_WITHOUT_GST_HC = 'misc_bank_referral_feetax_invoice_without_gst_hc',

  MISC_TAX_INVOICE_HINV = 'misc_tax_invoice_hinv',
  MISC_BANK_REFERRAL_FEETAX_INVOICE_HINV = 'misc_bank_referral_feetax_invoice_hinv',
  MISC_BANK_REFERRAL_FEETAX_INVOICE_WITHOUT_GST_HINV = 'misc_bank_referral_feetax_invoice_without_gst_hinv',

  MISC_TAX_INVOICE_HPL = 'misc_tax_invoice_hpl',
  MISC_BANK_REFERRAL_FEETAX_INVOICE_HPL = 'misc_bank_referral_feetax_invoice_hpl',
  MISC_BANK_REFERRAL_FEETAX_INVOICE_WITHOUT_GST_HPL = 'misc_bank_referral_feetax_invoice_without_gst_hpl',

  MISC_CREDIT_NOTE = 'misc_credit_note',
  BANK_REFERRAL_FEE_CREDIT_NOTE = 'bank_referral_fee_credit_note',

  MISC_CREDIT_NOTE_HI = 'misc_credit_note_hi',
  BANK_REFERRAL_FEE_CREDIT_NOTE_HI = 'bank_referral_fee_credit_note_hi',

  OTHERS_TAX_INVOICE = 'others_tax_invoice',
}

export enum InvoiceTemplateType {
  PROJECT_TAX_INVOICE = 'project_tax_invoice',
  RESALE_LEASE_TAX_INVOICE = 'resale_lease_tax_invoice',
  MISC_TAX_INVOICE = 'misc_tax_invoice',
  MISC_BANK_REFERRAL_FEE_TAX_INVOICE = 'misc_bank_referral_feetax_invoice',
  OTHERS_TAX_INVOICE = 'others_tax_invoice',
  PROJECT_HI_TAX_INVOICE = 'hi_tax_invoice',
  MISC_TAX_INVOICE_HI = 'misc_tax_invoice_hi',
  MISC_BANK_REFERRAL_FEE_TAX_INVOICE_HI = 'misc_bank_referral_feetax_invoice_hi',
  MISC_TAX_INVOICE_HC = 'misc_tax_invoice_hc',
  MISC_BANK_REFERRAL_FEETAX_INVOICE_HC = 'misc_bank_referral_feetax_invoice_hc',
  MISC_BANK_REFERRAL_FEETAX_INVOICE_WITHOUT_GST_HC = 'misc_bank_referral_feetax_invoice_without_gst_hc',
  MISC_TAX_INVOICE_HINV = 'misc_tax_invoice_hinv',
  MISC_BANK_REFERRAL_FEETAX_INVOICE_HINV = 'misc_bank_referral_feetax_invoice_hinv',
  MISC_BANK_REFERRAL_FEETAX_INVOICE_WITHOUT_GST_HINV = 'misc_bank_referral_feetax_invoice_without_gst_hinv',
  MISC_TAX_INVOICE_HPL = 'misc_tax_invoice_hpl',
  MISC_BANK_REFERRAL_FEETAX_INVOICE_HPL = 'misc_bank_referral_feetax_invoice_hpl',
  MISC_BANK_REFERRAL_FEETAX_INVOICE_WITHOUT_GST_HPL = 'misc_bank_referral_feetax_invoice_without_gst_hpl',
}